export default class modalManager{
    constructor(){

        /* 必要なDOM */
        this.root = document.getElementById('l-root');
        this.trigger = document.getElementsByClassName('js__modal');
        this.content = document.getElementsByClassName('c-modal');
        this.bg = document.getElementsByClassName('c-modal-bg');
        this.closeBtn = document.getElementsByClassName('c-modal-btn');
        this.num;
        this.posY = 0;
        // this.content = $('.p-style-kv-sp__list');
        // this.bg = $('.p-style-kv-sp__bg');
        // this.closeBtn = $('.p-style-kv-sp__list__close');
        // this.contentList = $('.p-style-kv-sp__list ul li');
        // this.hide = $('#l-scroll,#l-header,#p-style-kv');
        TweenMax.set(this.content,{scale:0.8});
        // TweenMax.set(this.bg,{
        //     display:'none',
        //     opacity:0
        // });
        /* 設定 */

        /* ステータス */

    }
    init() {
        let _this = this;
        for(this.num = 0;this.num < this.trigger.length; this.num++){

            let number = this.num

            this.trigger[this.num].onclick = function() {
                _this.open(number);
            };
            this.closeBtn[this.num].onclick = function () {
                _this.close(number);
            };
        }
        this.bg[0].onclick = function () {
            _this.closeAll();
        };
    }

    open(number) {
        //console.log(this.content[0]);
        TweenMax.set(this.root,{
           zIndex : 100,
        });
        TweenMax.to([this.content[number]],0.5,{
            opacity:1,
            display: 'block',
            scale:1,
            onComplete:()=>{
                this.scroll(number);
                this.center(number);
            }
        });
        TweenMax.to(this.bg[0],0.5,{
            opacity:0.9,
            display: 'block',
            scale:1
        });
    }
    close(number){
      let _this = this;
        TweenMax.to([this.content[number],this.bg[0]],0.5,{
            opacity:0,
            display: 'none',
            onComplete: function(){
              TweenMax.set(_this.root,{
                 zIndex : 1,
              });
            }
        });
        TweenMax.to([this.content[number]],0.5,{
            scale:0.8
        });

    }
    scroll(number){
        this.posY = window.pageYOffset + window.innerHeight/2 - this.content[number].clientHeight/2;
    }

    center(number){
        TweenMax.set(this.content[number],{
           top : this.posY
        });
    }

    closeAll(){
      let _this = this;
        TweenMax.to([this.content,this.bg],0.5,{
            opacity:0,
            display: 'none',
            onComplete: function(){
              TweenMax.set(_this.root,{
                 zIndex : 1,
              });
            }
        });
        TweenMax.to([this.content],0.5,{
            scale:0.8
        });
    }

}
